import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import ReactInputMask from "react-input-mask";

import DashboardLayout from "./components/Layout";

import { getEventByIdAdmin } from "../../api/plan";
import { createTicketAdmin, getTicketById, updateTicket } from "../../api/subscription";


export const paidBy = ['direct', 'cash', 'cardtocard', 'invitation', 'other'];

const TicketsFormPage = () => {
  const { eventId, id } = useParams();
  const [eventData, setEventData] = useState({});
  const [ticketData, setTicketData] = useState({});
  const isEdit = !!id;
  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { isSubmitting, isValid },
  } = useForm();

  const getEventData = async (eventId) => {
    const response = await getEventByIdAdmin(eventId); // get plan data instead
    setEventData(response?.data);
  };

  useEffect(() => {
    getEventData(eventId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);

  useEffect(() => {
    if (isEdit) {
      getTicketById(eventId, id).then((res) => {
        const data = res?.data?.data;
        setTicketData(data);
        if (data) {
          setValue("ticket", data.ticketTypeId?._id);
          setValue("name", data.name);
          setValue("email", data.email);
          setValue("phone", data.phone);
          setValue("paidBy", data.paidBy);
        }
      });
    }
  }, [isEdit, setValue, eventId, id]);

  const onSubmit = async (formData) => {
    const payload = {
      ticket: formData.ticket,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      paidBy: formData.paidBy,
      willSendEmail: formData.willSendEmail
    };

    if (isEdit) {
        await updateTicket(eventId, id, payload);
    } else {
        await createTicketAdmin(eventId, payload);
    }

    navigate(`/dashboard/${eventId}/tickets`);
  };

  return (
    <DashboardLayout id={eventId}>
      <div className="max-w-2xl mx-auto mt-10 bg-white p-8 rounded-xl shadow">
        <h2 className="text-2xl font-bold mb-6">
          {isEdit ? "📄 Bileti Düzəlt" : "➕ Yeni Bilet Əlavə Et"}
        </h2>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-3">
          <select
            id="ticket"
            {...register("ticket", { required: true })}
            className="w-full border border-gray-300 rounded-lg p-3 bg-white focus:outline-none focus:ring-2 focus:ring-black"
          >
            <option selected disabled value="">Bilet növü seçin</option>
            {eventData?.data?.ticketTypes?.map(({_id, name}) => <option value={_id} selected={_id === ticketData?.ticketTypeId?._id}>{name?.az}</option>)}
          </select>

          <div>
            <label className="block text-sm font-medium text-gray-700">Ad</label>
            <input
              {...register("name", { required: true })}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              {...register("email", { required: true })}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Telefon</label>
            <Controller
              control={control}
              name="phone"
              render={() => (
                <ReactInputMask
                  mask="099-999-9999"
                  id="phone"
                  {...register("phone", {
                    required: true,
                    pattern: /0\d\d-\d\d\d-\d\d\d\d/
                  })}
                  placeholder="(0XX) XXX-XX-XX"
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-black"
                  required
                />
              )}
            />
          </div>

          <select
            id="paidBy"
            {...register("paidBy", { required: true })}
            className="w-full border border-gray-300 rounded-lg p-3 bg-white focus:outline-none focus:ring-2 focus:ring-black"
          >
            <option selected disabled value="">Ödəmə forması seçin</option>
            {paidBy?.map(item => <option value={item}>{item}</option>)}
          </select>

          <div className="w-full items-center pt-2 pb-1">
            <div className="flex items-center">
              <input {...register("willSendEmail", {required: false})} id="checked-checkbox-agreement" type="checkbox" className="w-4 h-4 text-blue-700 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2" />
              <label className="ms-2 text-sm font-medium text-gray-800">Email göndərilsin?</label>
            </div>
          </div>

          <button
            type="submit"
            disabled={isSubmitting || !isValid}
            className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800 disabled:bg-gray-400"
          >
            {isEdit ? "Yadda saxla" : "Əlavə et"}
          </button>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default TicketsFormPage;
